import React from "react";
import { Spin } from "antd";
import { ICaseLawDocumentTypeListPresenter } from "../../presenter/CaseLawDocumentTypeListPresenter";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import CaseLawDocumentTypeGrid from "../components/CaseLawDocumentTypeGrid";

export interface Props extends PageProps {}

export interface State extends ICaseLawDocumentTypeListPresenter {}

export default class CaseLawDocumentTypePage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      caseLawDocumentTypes,
      createCaseLawDocumentType,
      updateCaseLawDocumentType
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.caseLawDocumentTypeLoader}>
            <CaseLawDocumentTypeGrid
              translate={translate}
              caseLawDocumentTypes={caseLawDocumentTypes}
              createCaseLawDocumentType={createCaseLawDocumentType}
              referenceLoader={this.state.loaders.caseLawDocumentTypeLoader}
              updateCaseLawDocumentType={updateCaseLawDocumentType}
            />
          </Spin>
        }
      </Page>
    );
  }
}
